export default "__VITE_ASSET__a3bdba29__"